import RankThree from '@assets/icons/rank-three.svg'
import { Icon } from './Icon'

export const RankThreeIcon = Icon(RankThree)
